import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import DefaultCard from '../../../../../../components/default/DefaultCard';
import DefaultToolBar from '../../../../../../components/default/DefaultToolBar';
import ButtonCreate from '../../../../../../components/buttons/ButtonCreate';
import DefaultModal from '../../../../../../components/default/DefaultModal';
import WarehouseHistoryDataTable from '../tables/WarehouseQuoteHistoryDataTable';
import { ServiceResponse } from '../../../../../../app/services/shared/interfaces';
import useSweetAlert from '../../../../../../hooks/useSweetAlert';
import { QuoteDataForm } from '../../../../../../app/models/Quote';
import useWarehouseHistoryService from '../../../../../../app/services/hooks/useWareHouseQuoteHistoryService';
import { Depot } from '../../../../../../app/models/Depot';
import useReactConfirmAlert from '../../../../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../../../../contexts/AppContext';
import { WarehouseQuoteHistory, WarehouseQuoteHistoryDataForm, WarehouseQuoteHistoryFilters } from '../../../../../../app/models/WareHouseQuoteHistory';

interface Props {
    quoteId: number;
    // storages: WarehouseQuoteHistoryDataForm;
    disableUpdate?: boolean;
    refresh?: number;

}

const WarehouseQuoteHistoryContainer = ({ 
    quoteId,
    disableUpdate = false,
     refresh,
     }: Props) => {
    const {
        getAllWarehouseQuoteHistorysByQuote,
        deleteWarehouseQuoteHistory,
        editWarehouseHistory,
        showWarehouseQuoteHistory,
        fetchingGetWarehouseQuoteHistorys
    } = useWarehouseHistoryService();
    const [storages, setHistorys] = useState<WarehouseQuoteHistoryDataForm>();
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);

    const [warehouseQuoteHistorys, setWarehouseQuoteHistorys] = useState<WarehouseQuoteHistory[]>([]);
    const [totalRows, setTotalRows] = useState<number>(0);
    const [filter, setFilter] = useState<WarehouseQuoteHistoryFilters>({
        page: 1,
        per_page: 10,
        sort: 'id',
        order: 'desc'
    });


    useEffect(() => {
        if (quoteId) reloadTable();
    }, [quoteId, filter, refresh]);

    const reloadTable = () => {
        getAllWarehouseQuoteHistorysByQuote(quoteId,filter,{
            onSuccess: (response: ServiceResponse) => {
                setWarehouseQuoteHistorys(response.data.warehouse_quote_history);
                setTotalRows(response.data.total_rows);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
            }
        });
    };

    return (
        <>
            <DefaultCard>
            <div className="h3 mt-0 mb-4 card-title">Historial</div> 
                <div className="row">
  
                    <div className="col-12">
                        <WarehouseHistoryDataTable
                            warehouseQuoteHistory={warehouseQuoteHistorys}
                            totalRows={totalRows}
                            loading={fetchingGetWarehouseQuoteHistorys}
                            filter={filter}
                            setFilter={setFilter}
                        />
                    </div>
                </div>
            </DefaultCard>

        </>
    );
};

export default WarehouseQuoteHistoryContainer;
